import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Protected({ children, role }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center text-neutral-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "coach" ? "/coach" : "/app/dashboard"} replace />;
  }
  if (user.role === "client" && !user.onboarding_complete && loc.pathname !== "/onboarding") {
    return <Navigate to="/onboarding" replace />;
  }
  return children;
}
